import { render, staticRenderFns } from "./EventQuestionWheelOfNames.vue?vue&type=template&id=44b02e15"
import script from "./EventQuestionWheelOfNames.vue?vue&type=script&lang=js"
export * from "./EventQuestionWheelOfNames.vue?vue&type=script&lang=js"
import style0 from "./EventQuestionWheelOfNames.vue?vue&type=style&index=0&id=44b02e15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports